module.exports = __webpack_public_path__ + "media/img/pages/companies/j-w-42449217d8072ec689442347829201f0.webp";